<template>
    <div class="charsData">
        <template v-if="(init && list.one && list.two && list.san) || LiveBasicList">
            <tableNav title="比赛数据"/>
            <div class="top">
                <div class="chars" v-if="list.one">
                    <liveChars
                    id="liveCharsOne"
                    :data='data.one'
                    :graphic="graphic.one"
                    :show="true"
                    :reverse="true"
                    :i="i"
                    :color=" ['#E56262','#548FEB'] "
                    />
                </div>
                <div v-else class="chars">
                    暂无数据！
                </div>
                <div class="chars" v-if="list.two">
                    <liveChars
                    id="liveCharsTwo"
                    :data='data.two'
                    :graphic="graphic.two"
                    :show="true"
                    :reverse="true"
                    :i="i"
                    :color=" ['#E56262','#548FEB'] "
                    />
                </div>
                <div v-else class="chars">
                    暂无数据！
                </div>
                <div class="chars" v-if="list.san">
                    <liveChars
                    id="liveCharsSan"
                    :data='data.san'
                    :graphic="graphic.san"
                    :show="true"
                    :reverse="true"
                    :i="i"
                    :color=" ['#E56262','#548FEB'] "
                    />
                </div>
                <div v-else class="chars">
                    暂无数据！
                </div>
            </div>
            <div class="bottom" v-if="LiveBasicList">
                <div class="box">
                    <div class="list">
                        <matchNum
                        type="one"
                        :data="LiveBasicList"
                        />
                    </div>
                </div>
                <div class="foter">
                    <span>{{home_team_name}}</span>
                    <span>{{away_team_name}}</span>
                </div>
            </div>
        </template>
        <template v-else>
            <div class="empty">
                <span><img src="../../assets/img/matchDetails/empty.png" alt=""></span>
                <span>暂无数据！</span> 
            </div>
        </template>
    </div>
</template>

<script>
import tableNav from "../../components/match/common/table_nav.vue"
import matchNum from "../../components/match/common/matchNum.vue"
import liveChars from "../../components/match/common/pie.vue"
import { matchLiveBasicListExt,matchTeamStatics } from "../../api/api"
export default {
    name: "charsData",
    props: ['baseInfo', 'match_id', 'away_team_name', 'home_team_name', 'status', 'tabs'],
    components: {
        tableNav,
        matchNum,
        liveChars
    },
    data () {
        return {
            init: true,
            time: null,
            list:{
                one:null,
                two:null,
                san:null
            },
            graphic: {
                one: [],
                two: [],
                san: []
            },
            data: {
                one: [],
                two: [],
                san: []
            },
            LiveBasicList: null,
            TeamStaticsL: null,
            i: 1
        }
    },
    watch: {
        tabs: {
            handler (news) {
                if (news == 3) {
                    this.$nextTick(() => {
                        this.forFun()
                    })
                    
                } else {
                    clearInterval(this.time)
                }
            },
            immediate: true
        },
        match_id () {
            this.forFun()
        }
    },
    // created () {
    //     this.getTeamStatics()
    // },
    mounted() {
        this.getLiveBasicList()
        this.getTeamStatics().then(() => {
            this.getList()
        })
    },
    methods: {
        forFun () {
            clearInterval(this.time)
            if (this.tabs != 3) return
            if (this.status == 2) {
                this.getLiveBasicList()
                this.getTeamStatics().then(() => {
                    this.getList()
                    // this.init = true
                })
                this.time = setInterval (() => {
                    this.getLiveBasicList()
                    this.getTeamStatics().then(() => {
                        this.getList()
                        // this.init = true
                    })
                },30000)
            } else {
                clearInterval(this.time)
                // this.init = false
                this.getLiveBasicList()
                this.getTeamStatics().then(() => {
                    this.getList()
                    // this.init = true
                })
            }
        },
        async getLiveBasicList () {
            let params = {
                match_id: this.match_id
            }
            let params2 = {}
            if (this.status == 2) {
                params2.r = parseInt(new Date().getTime() / 1000) 
            }
            const res = await matchLiveBasicListExt(params,params2)
            if (res.code == 0) {
                this.LiveBasicList = res.data
            }
        },
        // 三个圈
        async getTeamStatics () {
            let params = {
                match_id: this.match_id
            }
            let params2 = {}
            if (this.status == 2) {
                params2.r = parseInt(new Date().getTime() / 1000) 
            }
            const res = await matchTeamStatics(params,params2)
            if (res.code == 0) {
                this.TeamStaticsL = res.data
            }
        },
        getList () {
            this.list.one = null
            this.list.two = null
            this.list.san = null
            let res = this.TeamStaticsL || []
            for (let i = 0; i < res.length; i++){
                if (res[i].type_id == '1') {
                    this.list.one = res[i]
                }
                if (res[i].type_id == '17') {
                    this.list.two = res[i]
                }
                if (res[i].type_id == '18') {
                    this.list.san = res[i]
                }
            }
            if (this.list.one) {
                this.graphic.one = [
                    { // 环形图中间添加文字
                        type: 'text', // 通过不同top值可以设置上下显示
                        left: '15%',
                        top: '53%%',
                        style: {
                            text:  this.list.one.team1,
                            textAlign: 'center',
                            fill: '#444444', // 文字的颜色
                            fontSize: 14,
                            fontWeight: 400
                        }
                    },
                    { // 环形图中间添加文字
                        type: 'text', // 通过不同top值可以设置上下显示
                        left: '80%',
                        top: '53%%',
                        style: {
                            text:  this.list.one.team2,
                            textAlign: 'center',
                            fill: '#444444', // 文字的颜色
                            fontSize: 14,
                            fontWeight: 400
                        }
                    },
                    { // 环形图中间添加文字
                        type: 'text', // 通过不同top值可以设置上下显示
                        top: '53%%',
                            left: 'center',
                            // position: 'center',

                        style: {
                            text:  '控球率',
                            textAlign: 'center',
                            fill: '#444444', // 文字的颜色
                            fontSize: 14,
                            fontWeight: 400
                        }
                    }
                ]
                this.data.one =[
                    { value: this.list.one.team2, name:this.away_team_name},
                    { value: this.list.one.team1, name:this.home_team_name}
                ]
            }
            if (this.list.two) {
                this.graphic.two = [
                    { // 环形图中间添加文字
                        type: 'text', // 通过不同top值可以设置上下显示
                        left: '15%',
                        top: '53%%',
                        style: {
                            text:  this.list.two.team1,
                            textAlign: 'center',
                            fill: '#444444', // 文字的颜色
                            fontSize: 14,
                            fontWeight: 400
                        }
                    },
                    { // 环形图中间添加文字
                        type: 'text', // 通过不同top值可以设置上下显示
                        left: '80%',
                        top: '53%%',
                        style: {
                            text:  this.list.two.team2,
                            textAlign: 'center',
                            fill: '#444444', // 文字的颜色
                            fontSize: 14,
                            fontWeight: 400
                        }
                    },
                    { // 环形图中间添加文字
                        type: 'text', // 通过不同top值可以设置上下显示
                        top: '53%%',
                            left: 'center',
                            // position: 'center',

                        style: {
                            text:  '进攻次数',
                            textAlign: 'center',
                            fill: '#444444', // 文字的颜色
                            fontSize: 14,
                            fontWeight: 400
                        }
                    }
                ]
                this.data.two =[
                    { value: this.list.two.team2, name:this.away_team_name},
                    { value: this.list.two.team1, name:this.home_team_name}
                ]
            }
            if (this.list.san) {
                this.graphic.san = [
                    { // 环形图中间添加文字
                        type: 'text', // 通过不同top值可以设置上下显示
                        left: '15%',
                        top: '53%%',
                        style: {
                            text:  this.list.san.team1,
                            textAlign: 'center',
                            fill: '#444444', // 文字的颜色
                            fontSize: 14,
                            fontWeight: 400
                        }
                    },
                    { // 环形图中间添加文字
                        type: 'text', // 通过不同top值可以设置上下显示
                        left: '80%',
                        top: '53%%',
                        style: {
                            text:  this.list.san.team2,
                            textAlign: 'center',
                            fill: '#444444', // 文字的颜色
                            fontSize: 14,
                            fontWeight: 400
                        }
                    },
                    { // 环形图中间添加文字
                        type: 'text', // 通过不同top值可以设置上下显示
                        top: '53%%',
                            left: 'center',
                            // position: 'center',

                        style: {
                            text:  '危险进攻',
                            textAlign: 'center',
                            fill: '#444444', // 文字的颜色
                            fontSize: 14,
                            fontWeight: 400
                        }
                    }
                ]
                 this.data.san =[
                    { value: this.list.san.team2, name:this.away_team_name},
                    { value: this.list.san.team1, name:this.home_team_name}
                ]
            }
            this.i++
        }
    }
}
</script>

<style lang="less">
.charsData{
    .empty{
        height: 600px;
        // box-shadow: 0px 0px 20px 0px rgba(21, 21, 21, 0.06);
        display: flex;
        flex-direction: column;
        justify-content: center;
        span{
            font-size: 14px;
            font-weight: 400;
            color: #333333;
            text-align: center;
            &:first-child{
                padding-top:32px ;
                margin-bottom:10px ;
                display: flex;
                justify-content: center;
                align-items: center;
                img{
                  width: 180px;
                 height: 140px;  
                }
                
            }
        }
    }
    margin-top: 10px;
    .top{
        display: flex;
        justify-content: space-between;
        .chars{
            width: 300px;
            height: 226px;
            background: #FFFFFF;
            box-shadow: 0px 0px 20px 0px rgba(21, 21, 21, 0.06);
            padding-top:20px ;
            text-align: center;
        }
    }
    .bottom{
        margin-top:10px ;
        padding:20px ;
        padding-bottom:none ;
        // height: 314px;
        background: #FFFFFF;
        box-shadow: 0px 0px 20px 0px rgba(21, 21, 21, 0.06);
        .box{
            // height: 240px;
            display: flex;
            justify-content: center;
            .list{
                width: 100%;
            }
        }
        .foter{
            height: 52px;
            display: flex;
            span{
                flex: 1;
                font-size: 12px;
                height: 52px;
                font-weight: 400;
                color: #444444;
                line-height: 52px;
                margin-right: 20px;
                &:first-child{
                    text-align: right;
                    &::before{
                        content: '';
                        display: inline-block;
                        width: 10px;
                        height: 10px;
                        background: #E05C5C;
                        margin-right:10px ;
                    }
                }
                &:last-child{
                    text-align: left;
                    margin-left:20px ;
                    &::before{
                        content: '';
                        display: inline-block;
                        width: 10px;
                        height: 10px;
                        background: #548FEB;
                        margin-right:10px ;
                    }
                }
            }
        }
    }
}
</style>